var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.405,
    height: 19.405,
    viewBox: "0 0 19.405 19.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#78849e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.272 -35.973)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.8,38.132a3.591,3.591,0,0,1,3.553,3.1l-.263-.263a.654.654,0,0,0-1.118.463.646.646,0,0,0,.192.463l1.413,1.414a.655.655,0,0,0,.927,0L26.919,41.9a.654.654,0,0,0,0-.926.67.67,0,0,0-.926,0l-.314.314A4.9,4.9,0,0,0,20.8,36.822a.655.655,0,1,0,0,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.022,45.021H18.629V36.628a.655.655,0,0,0-.655-.655H8.927a.656.656,0,0,0-.655.655V50.2a.656.656,0,0,0,.655.655H12.8v3.868a.655.655,0,0,0,.655.655H27.022a.656.656,0,0,0,.655-.655V45.676A.656.656,0,0,0,27.022,45.021Zm-.655,1.31v7.737H14.106V50.855h3.868a.655.655,0,0,0,.655-.655V46.331Zm-9.048-9.048V49.545H9.582V37.283Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCw);
export default __webpack_public_path__ + "static/media/rotate-cw.06af25af34f56fd00c2380e61c1cb203.svg";
export { ForwardRef as ReactComponent };